import { useMutation, useQueryClient } from 'react-query-v5';
import { msalInstance, useAuthStore } from '@sib/auth';
import {
  clearLocalStorage,
  updateUserId,
  storageKeys,
} from '@spendbrain/common/utils';

export const useLogout = () => {
  const { setAccount } = useAuthStore();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async () => {
      clearLocalStorage({ persistValueKeys: [storageKeys.userSetupStore] });
      queryClient.clear();
      sessionStorage.clear();
      await msalInstance.logoutRedirect({
        onRedirectNavigate: () => false,
      });
      setAccount(null);

      updateUserId();

      window.location.reload();
    },
  });
};
